import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Klávesové zkratky (kap. 37): Ctrl/Cmd+K nebo „/" otevře paletu, „n" nová faktura,
 * „g" + písmeno skočí na obrazovku, „?" ukáže nápovědu. Nic z toho se nechytá, když píšeš
 * do pole, aby zkratky nepřekážely při vyplňování.
 */
const GO: Record<string, string> = {
  h: '/',
  d: '/doklady',
  p: '/platby',
  s: '/sklad',
  r: '/prehledy',
  u: '/vice/ucetni',
  k: '/vice/kontakty',
  z: '/zakazky',
  w: '/weby',
  a: '/asistent',
  c: '/kalendar',
  // úkoly mozku (t = tasks) a reklamy (m = Meta)
  t: '/ukoly',
  m: '/reklamy',
  n: '/vice/nastaveni',
  v: '/vice/navody',
};

function typing(target: EventTarget | null): boolean {
  const el = target as HTMLElement | null;
  if (!el) return false;
  const tag = el.tagName;
  return tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || el.isContentEditable;
}

export function useShortcuts(opts: { openPalette: () => void; toggleHelp: () => void }) {
  const navigate = useNavigate();
  const pendingG = useRef<number | null>(null);
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        opts.openPalette();
        return;
      }
      if (e.ctrlKey || e.metaKey || e.altKey || typing(e.target)) return;
      if (e.key === '/') {
        e.preventDefault();
        opts.openPalette();
        return;
      }
      if (e.key === '?') {
        opts.toggleHelp();
        return;
      }
      if (pendingG.current) {
        window.clearTimeout(pendingG.current);
        pendingG.current = null;
        const path = GO[e.key.toLowerCase()];
        if (path) {
          e.preventDefault();
          navigate(path);
        }
        return;
      }
      if (e.key === 'g') {
        pendingG.current = window.setTimeout(() => {
          pendingG.current = null;
        }, 1200);
        return;
      }
      if (e.key === 'n') {
        e.preventDefault();
        navigate('/novy');
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [navigate, opts]);
}
